'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var _ = require('lodash');
var displayNames = require('./displayNames');
var compose = require('../hoc/compose');
var template = require('./fontFamilyPicker.rt');

var DEFAULT_EXAMPLES = {
    latin: '',
    'latin-ext': 'Gałąź',
    cyrillic: 'Пример',
    japanese: 'あア愛Aa',
    korean: '미리보기',
    arabic: 'مثال',
    hebrew: 'דוגמא'
};

var DEFAULT_FONT_GROUPS = {
    'my-uploads': 'My Fonts',
    latin: 'All Fonts',
    'latin-ext': 'Eastern European',
    cyrillic: 'Cyrillic',
    japanese: 'Japanese',
    korean: 'Korean',
    arabic: 'Arabic',
    hebrew: 'Hebrew'
};

var FontFamilyPicker = function (_React$Component) {
    _inherits(FontFamilyPicker, _React$Component);

    function FontFamilyPicker(props) {
        _classCallCheck(this, FontFamilyPicker);

        var _this = _possibleConstructorReturn(this, (FontFamilyPicker.__proto__ || Object.getPrototypeOf(FontFamilyPicker)).call(this, props));

        _this.fontExamplesMap = _.defaults(props.fontExamplesMap, DEFAULT_EXAMPLES);
        _this.fontGroupsNamesMap = _.defaults(props.fontGroupsNamesMap, DEFAULT_FONT_GROUPS);

        _this.state = {
            fontsItems: _this.getFontsItems(_this.props.fonts)
        };
        return _this;
    }

    _createClass(FontFamilyPicker, [{
        key: 'getMissingFontName',
        value: function getMissingFontName() {
            if (this.isMissingFont()) {
                return this.props.getMissingFontName(this.props.value);
            }
        }
    }, {
        key: 'getFontsItems',
        value: function getFontsItems(fontsArr) {
            var _this2 = this;

            var fontItems = [];

            _.forEach(fontsArr, function (lang) {
                fontItems.push({
                    groupName: _this2.fontGroupsNamesMap[lang.lang]
                });

                _.forEach(lang.fonts, function (font) {
                    if (font.permissions !== 'legacy') {

                        var fontItem = {
                            label: font.displayName,
                            value: font.fontFamily,
                            example: _this2.fontExamplesMap[lang.lang],
                            cssFontFamily: font.cssFontFamily
                        };

                        fontItems.push(fontItem);
                    }
                });
            });

            return fontItems;
        }
    }, {
        key: 'isMissingFont',
        value: function isMissingFont() {
            return !_.find(this.state.fontsItems, { value: this.props.value });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.fontExamplesMap = _.defaults(nextProps.fontExamplesMap, DEFAULT_EXAMPLES);
            this.fontGroupsNamesMap = _.defaults(nextProps.fontGroupsNamesMap, DEFAULT_FONT_GROUPS);

            if (!_.isEqual(this.props.fonts, nextProps.fonts)) {
                this.setState({ fontsItems: this.getFontsItems(nextProps.fonts) });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return template.call(this);
        }
    }]);

    return FontFamilyPicker;
}(React.Component);

FontFamilyPicker.displayName = displayNames.FONT_FAMILY_PICKER;

FontFamilyPicker.defaultProps = {
    toolbarMode: false
};

FontFamilyPicker.propTypes = {
    value: React.PropTypes.string,
    onChange: React.PropTypes.func,
    footerLinks: React.PropTypes.arrayOf(React.PropTypes.shape({
        label: React.PropTypes.string.isRequired,
        onClick: React.PropTypes.func.isRequired,
        symbol: React.PropTypes.element
    })),
    fonts: React.PropTypes.arrayOf(React.PropTypes.shape({
        fonts: React.PropTypes.arrayOf(React.PropTypes.shape({
            cssFontFamily: React.PropTypes.string.isRequired,
            displayName: React.PropTypes.string.isRequired,
            fontFamily: React.PropTypes.string.isRequired,
            permissions: React.PropTypes.string
        }).isRequired),
        lang: React.PropTypes.string
    }).isRequired),
    getMissingFontName: React.PropTypes.func.isRequired,
    toolbarMode: React.PropTypes.bool,
    shouldTranslate: React.PropTypes.bool,
    fontGroupsNamesMap: React.PropTypes.object,
    fontExamplesMap: React.PropTypes.object,
    disabled: React.PropTypes.bool
};

module.exports = compose(FontFamilyPicker);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/fontFamilyPicker.js